import { Chip, Stack, Tooltip } from "@mui/material";

export interface DiscrepanciesCellProps {
  unresolvedCount: number;
  pendingCount: number;
}

/**
 * Combined discrepancies column: side-by-side chips when a manifest has both
 * unresolved and pending rows. Unresolved uses warning styling; pending uses
 * info — matching the detail drawer and legacy two-column layout.
 */
export function DiscrepanciesCell({ unresolvedCount, pendingCount }: DiscrepanciesCellProps) {
  if (unresolvedCount === 0 && pendingCount === 0) {
    return null;
  }

  const tooltipParts: string[] = [];
  if (unresolvedCount > 0) {
    tooltipParts.push(
      `${unresolvedCount} unresolved ${unresolvedCount === 1 ? "field" : "fields"} need review`
    );
  }
  if (pendingCount > 0) {
    tooltipParts.push(
      `${pendingCount} pending ${pendingCount === 1 ? "review" : "reviews"} awaiting confirmation`
    );
  }

  return (
    <Tooltip title={tooltipParts.join(" · ")} placement="top" enterDelay={400}>
      <Stack direction="row" spacing={0.5} alignItems="center">
        {unresolvedCount > 0 && (
          <Chip label={unresolvedCount} size="small" color="warning" variant="outlined" />
        )}
        {pendingCount > 0 && (
          <Chip label={pendingCount} size="small" color="info" variant="outlined" />
        )}
      </Stack>
    </Tooltip>
  );
}
